var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.99,
    height: 16.084,
    viewBox: "0 0 26.99 16.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(0 -98.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9395",
    "data-name": "Path 9395",
    d: "M13.495,98.725c-5.157,0-9.833,2.821-13.284,7.4a1.068,1.068,0,0,0,0,1.275c3.451,4.588,8.127,7.409,13.284,7.409s9.833-2.821,13.284-7.4a1.068,1.068,0,0,0,0-1.275C23.328,101.546,18.651,98.725,13.495,98.725Zm.37,13.709a5.677,5.677,0,1,1,5.3-5.3,5.677,5.677,0,0,1-5.3,5.3Zm-.171-2.617a3.057,3.057,0,1,1,2.854-2.854,3.057,3.057,0,0,1-2.854,2.854Z",
    fill: "#383c3a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.dc6eeba96610be04ada6c0e0ba51fdba.svg";
export { ForwardRef as ReactComponent };